import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const [form, setForm] = useState({ phone: '', password: '' });
  const [showPwd, setShowPwd] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!/^1[3-9]\d{9}$/.test(form.phone)) { toast.error('请输入正确的手机号码'); return; }
    if (!agreed) { toast.error('请阅读并同意用户服务协议与隐私政策'); return; }
    try {
      const { data } = await api.post('/login', { phone: form.phone, password: form.password });
      localStorage.setItem('token', data.token);
      toast.success('登录成功');
      navigate('/');
    } catch (err: any) { toast.error(err?.response?.data?.message ?? '错误'); }
  }

  return (
    <div className="min-h-screen w-full flex flex-col bg-[url(/images/auth_beijng.png)] bg-cover bg-no-repeat bg-top pb-[150px]"> 
      {/* Login form card */}
      <div className="px-4 mt-[330px] relative z-10">
        <div className="p-6 rounded-xl bg-[url(/images/auth_kuang.png)] bg-cover bg-no-repeat bg-top pt-[100px]"> 
          <form onSubmit={submit} className="space-y-3">
            {/* Phone field */}
            <div className="flex items-center bg-[#fff]/60 rounded-md px-4 py-2.5 border border-[#ff6666]/20">
              <img src="/images/auth_shouji.png" alt="" className="w-5 h-5 mr-3 flex-shrink-0" />
              <input
                className="flex-1 text-sm focus:outline-none bg-transparent"
                placeholder="请输入手机号 / 账号"
                maxLength={11}
                value={form.phone}
                onChange={e => setForm({ ...form, phone: e.target.value.replace(/\D/g, '').slice(0, 11) })}
              />
            </div>

            {/* Password field */}
            <div className="flex items-center bg-[#fff]/60 rounded-md px-4 py-2.5 border border-[#ff6666]/20">
              <img src="/images/auth_mimam.png" alt="" className="w-5 h-5 mr-3 flex-shrink-0" />
              <input
                className="flex-1 text-sm focus:outline-none bg-transparent"
                placeholder="请输入登录密码"
                type={showPwd ? 'text' : 'password'}
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
              />
              <button type="button" onClick={() => setShowPwd(!showPwd)} className="ml-2 flex-shrink-0">
                <img src="/images/auth_yanjing.png" alt="" className="w-5 h-4" style={{ opacity: showPwd ? 1 : 0.5 }} />
              </button>
            </div>

            {/* Agreement */}
            <label className="flex items-center gap-2 justify-start cursor-pointer select-none">
              <div
                className={`w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors text-[#fff] ${agreed ? 'bg-[#ca0000] border-[#ca0000]/30' : 'border-[#ca0000]/50'}`}
                onClick={() => setAgreed(!agreed)}
              >
                {agreed && <span className="text-[#fff] text-[8px] leading-none">&#10003;</span>}
              </div>
              <span className="text-[11px]">
                我已阅读并同意
                <a href="/agreement" className="text-[#ca0000]" onClick={e => e.stopPropagation()}>《用户服务协议》</a>
                与
                <a href="/privacy" className="text-[#ca0000]" onClick={e => e.stopPropagation()}>《隐私政策》</a>
              </span>
            </label>

            {/* Login button */}
            <button
              type="submit"
              className="w-full" 
            >
              <img src="/images/auth_liji.png" alt="" className="w-full" />
            </button>

          <div className="flex justify-between mt-2">
            <span></span>
            <span className="text-center text-[11px] text-black">还没有账号 <a href="/register" className="text-[#ca0000]">立即注册</a></span>
          </div>
          </form>
        </div>

        {/* Action cards */}
        <div className="flex gap-3 mt-5">
          <a href="/support" className="flex-1">
            <img src="/images/auth_kefu.png" alt="" className="w-full flex-shrink-0" />
          </a>
          <a href="/download" className="flex-1">
            <img src="/images/auth_xiazai.png" alt="" className="w-full flex-shrink-0" />
          </a>
        </div>
      </div> 
    </div >
  );
}
